import {useAppContext} from "../../../../context/Context";
import api from "../../../../utils/api";
import {setBottomBarError, setBottomBarSucces} from "../../../../utils/Functions";
import useConfiguration from "./useConfiguration";
import {useEffect, useState} from "react";
import {ACTION} from "../../../../context/actionTypes";

export interface AvailableModel {
    id: string;
    created: string;
    owned_by: string;
}

export default function useInference() {
    const [, dispatch] = useAppContext();
    const [
        {configuration, modifiedKeys, isModified},
        {editUnsavedConfiguration, saveConfiguration},
    ] = useConfiguration();

    const toggleMe = () => dispatch({ type: ACTION.SET_GENERIC_MODAL, payload: null });

    const [availableModels, setAvailableModels] = useState<AvailableModel[]>([]);

    useEffect(() => {
        async function loadAvailableModels() {
            try {
                const response = await api.get("/configuration/inference-models");
                setAvailableModels(response.data);
            } catch (e) {
                setBottomBarError(dispatch, e);
            }
        }

        loadAvailableModels().catch(console.error);
    }, [dispatch]);

    // Handle toggle changes
    function handleToggleQuestions() {
        editUnsavedConfiguration({questions_enabled: !configuration.questions_enabled});
    }

    function handleToggleDocumentsUpload() {
        editUnsavedConfiguration({documents_upload_enabled: !configuration.documents_upload_enabled});
    }

    function handleCompletionsModelChange(event) {
        editUnsavedConfiguration({completions_model: event.target.value.id});
    }

    function handleTeiModelChange(event) {
        editUnsavedConfiguration({tei_model: event.target.value.id});
    }

    function handleNumberChange(event) {
        const {name, value} = event.target;
        editUnsavedConfiguration({[name]: Number(value)});
    }


    return [
        {configuration, modifiedKeys, isModified, availableModels},
        {handleToggleQuestions, handleToggleDocumentsUpload, handleCompletionsModelChange, handleTeiModelChange, handleNumberChange, saveConfiguration, toggleMe, dispatch},
    ];
}
